import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import LoginPage from "./pages/LoginPage";
import AdminPage from "./pages/AdminPage";
import EngineerDashboard from "./pages/EngineerDashboard";
import CustomerDashboard from "./pages/CustomerDashboard";
import ProductDetailPage from "./pages/ProductDetailPage";
import EspaPage from "./pages/EspaPage";
import { LanguageProvider } from "./i18n/LanguageContext";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/engineer" element={<EngineerDashboard />} />
            <Route path="/customer" element={<CustomerDashboard />} />
            <Route path="/product/:id" element={<ProductDetailPage />} />
            <Route path="/espa" element={<EspaPage />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
